import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type GiftCardCodeFragment = { id: string, pk: number, amount: any, date: any, email: string, isActive: boolean, transactionStatus: string, transactionType: Types.TransactionTypeEnum, voucherCode: string, balanceData: any, availableBalance: number, expires: any };

export const GiftCardCodeFragmentDoc = gql`
    fragment GiftCardCodeFragment on VoucherTransactionType {
  id
  pk
  amount
  date
  email
  isActive
  transactionStatus
  transactionType
  voucherCode
  balanceData
  availableBalance
  expires
}
    `;